import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AirdiskbrakeService } from 'src/app/services/feature/airdisk-brake/airdiskbrake.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-airdisk-friction-maintainance',
  templateUrl: './airdisk-friction-maintainance.component.html',
  styleUrls: ['./airdisk-friction-maintainance.component.scss'],
  standalone: false
})
export class AirdiskFrictionMaintainanceComponent {
  private readonly destroy$ = new Subject<void>();
  @Input() adbDropDownData: any;
  fleetInfoData: any;
  E34: any;
  E35: any;
  E36: any;
  E37: any;
  subscription = new Subscription();
  isTractor: boolean = false;
  constructor(public airdiskService: AirdiskbrakeService, private readonly cdr: ChangeDetectorRef) {

  }

  ngOnInit() {
    this.subscription = this.airdiskService.selectedOption$.subscribe(option => {
      if (option) {
        this.isTractor = option === 'Tractor';
      } else {
        this.isTractor = true;
      }
    });


    this.airdiskService.fleetInfoData$.pipe(takeUntil(this.destroy$)).subscribe(x => {
      this.fleetInfoData = x;
    });

    this.frictionDrumMaintainance();

    console.log(this.frictionDrumMaintainanceForm.value);

    this.calculateAndSetSum();
  }

  frictionDrumMaintainance() {
    this.airdiskService.frictionDrumMaintainance$.pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        console.log('frictionDrumMaintainance', data);
        if (data != null) {
          this.formData(data);
          if (this.isTractor) {
            this.frictionDrumMaintainanceForm.controls['drumReplacementUnitCost'].setValue(600.00);
            this.frictionDrumMaintainanceForm.controls['drumBreakShoeReplacementUnitCost'].setValue(360.00);
          } else {
            this.frictionDrumMaintainanceForm.controls['drumReplacementUnitCost'].setValue(400.00);
            this.frictionDrumMaintainanceForm.controls['drumBreakShoeReplacementUnitCost'].setValue(240.00);
          }
        }
      });
  }

  formData(data) {
    this.frictionDrumMaintainanceForm.patchValue({
      averageMilageToChangeFriction: data.averageMilageToChangeFriction || 400000,
      brakeFrictionRequirementAtTradeIn: data.brakeFrictionRequirementAtTradeIn || 1,
      drumBreakShoeReplacementUnitCost: data.drumBreakShoeReplacementUnitCost != null ? data.drumBreakShoeReplacementUnitCost.toFixed(2) : (this.isTractor ? 360.00 : 240.00),
      drumReplacementUnitCost: data.drumReplacementUnitCost != null ? data.drumReplacementUnitCost.toFixed(2) : (this.isTractor ? 600.00 : 400.00),
      noOfFrictionReplacementsAtTradeIn: data.noOfFrictionReplacementsAtTradeIn || this.isTractor ? 1 : 2,
      noOfDrumReplacementsAtTradeIn: data.noOfDrumReplacementsAtTradeIn || this.isTractor ? 1 : 2,
      drumBreakReplacementUnitCost: data.drumBreakReplacementUnitCost.toFixed(2) || this.isTractor ? 1740 : 2320,
      drumBreakReplacementFleetCost: data.drumBreakReplacementFleetCost.toFixed(2) || this.isTractor ? 1740000.00 : 2320000.00,
    })
  }

  frictionDrumMaintainanceForm = new FormGroup({
    averageMilageToChangeFriction: new FormControl(400000, { validators: Validators.required }),
    brakeFrictionRequirementAtTradeIn: new FormControl(1, { validators: Validators.required }),
    drumBreakShoeReplacementUnitCost: new FormControl(this.isTractor ? 360 : 240, { validators: Validators.required }),
    drumReplacementUnitCost: new FormControl(this.isTractor ? 600.00 : 400.00, { validators: Validators.required }),
    noOfFrictionReplacementsAtTradeIn: new FormControl(null, { validators: Validators.required }),
    noOfDrumReplacementsAtTradeIn: new FormControl(null, { validators: Validators.required }),
    drumBreakReplacementUnitCost: new FormControl(null, { validators: Validators.required }),
    drumBreakReplacementFleetCost: new FormControl(null, { validators: Validators.required }),
  });
  get form() {
    return this.frictionDrumMaintainanceForm.controls;
  }

  onFormChanges(): void {
    this.frictionDrumMaintainanceForm.get('annualFleetAccidentRate')?.valueChanges.subscribe(() => {
      this.calculateAndSetSum();
    });

    this.storeDataOnChange();
  }

  calculateAndSetSum(): void {
    //Section 4
    const E30 = +this.frictionDrumMaintainanceForm.get('averageMilageToChangeFriction')?.value || 0;
    const E31 = +this.frictionDrumMaintainanceForm.get('brakeFrictionRequirementAtTradeIn')?.value || 0;
    const E32 = +this.frictionDrumMaintainanceForm.get('drumBreakShoeReplacementUnitCost')?.value || 0;
    const E33 = +this.frictionDrumMaintainanceForm.get('drumReplacementUnitCost')?.value || 0;
    const E128 = +this.frictionDrumMaintainanceForm.get('noOfFrictionReplacementsAtTradeIn')?.value || 1;
    //Fleet Information:
    const E13 = this.fleetInfoData?.fleetSize;
    const E14 = this.fleetInfoData?.totalNumberOfAxlesPerUnit;
    const E15 = this.isTractor ? this.fleetInfoData?.tractorTradeInCycle : this.fleetInfoData?.trailerTradeInCycle;
    const E16 = this.fleetInfoData?.averageAnnualUnitMilage;
    const E17 = this.fleetInfoData?.drumToShoeReplacementFrequency;

    const E20 = this.fleetInfoData?.fleetMaintenanceLaborRate;

    //I34 : =ROUNDDOWN(E16*E15/E30,0) =ROUNDDOWN(E16*E15/E30,0)
    //I35 : =I34+IF(E16*E15/E30-I34<0.5,0,1)
    const I34 = Math.floor(E16 * (E15 / E30));
    const I35 = I34 + ((E16 * (E15 / E30) - I34) < 0.5 ? 0 : 1);
    //E112 = E17
    //E128 = noOfFrictionReplacementsAtTradeIn
    const I112 = Math.floor(E17 === 2 ? E128 / 2 : 0); //=ROUNDDOWN(IF(E112=2,E128/2,0),0)




    if (this.isTractor) {
      this.E34 = (E31 === 1) ? I35 : I34;
      this.E35 = (E17 === 1) ? this.E34 : E33;
      //E36 -> =((E14*2*1*E20+E32)*E34+E33*E35)
      this.E36 = ((E14 * 2 * 1 * E20 + E32) * this.E34 + E33 * this.E35);
      this.E37 = this.E36 * E13;
    }
    else {
      this.E34 = Math.floor(E16 * E15 / E30);
      this.E35 = Math.floor((E17 === 1) ? this.E34 : I112);
      this.E36 = ((E14 * 2 * 1 * E20 + E32) * this.E34 + E33 * this.E35);
      this.E37 = this.E36 * E13;
    }


    this.frictionDrumMaintainanceForm.patchValue({
      noOfFrictionReplacementsAtTradeIn: this.E34,
      noOfDrumReplacementsAtTradeIn: this.E35,
      drumBreakReplacementUnitCost: this.E36.toFixed(2),
      drumBreakReplacementFleetCost: this.E37.toFixed(2)
    });
  }

  storeDataOnChange() {

    if (this.frictionDrumMaintainanceForm.valid) {
      this.frictionDrumMaintainanceForm.patchValue({
        drumBreakShoeReplacementUnitCost: Number(this.frictionDrumMaintainanceForm.controls['drumBreakShoeReplacementUnitCost'].value),
        drumReplacementUnitCost: Number(this.frictionDrumMaintainanceForm.controls['drumReplacementUnitCost'].value),
        drumBreakReplacementUnitCost: Number(this.frictionDrumMaintainanceForm.controls['drumBreakReplacementUnitCost'].value),
        drumBreakReplacementFleetCost: Number(this.frictionDrumMaintainanceForm.controls['drumBreakReplacementFleetCost'].value),
      });
      this.airdiskService.frictionDrumMaintainance$.next(this.frictionDrumMaintainanceForm.value);
    }
    else {
      this.frictionDrumMaintainanceForm.markAllAsTouched();
    }
    this.cdr.detectChanges();
  }

  endaSureNxt() {
    this.storeDataOnChange();
    this.airdiskService.currentComponent$.next('drumBreakCosts');
  }

  endaSureBack() {
    this.airdiskService.currentComponent$.next('fleetSafety');
    this.storeDataOnChange();
  }

  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.subscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

}
